// extracted by mini-css-extract-plugin
export default {"details":"NatqZ4WJGouWoAJa4j3DAw==","detail":"_0rF-l9ccKloL-Ac2EFez1w==","label":"u0K4NAr8C2+4Ug1kf4Ovfg==","DE":"ZSfFnmfh6UHH0vaPNHLEyA=="};